module.exports = __webpack_public_path__ + "static/thiefery-ad6d5b2e78522b6201838548edebd720.gif";